module.exports = __webpack_public_path__ + "static/img/login.d586706.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login.jpg
// module id = 695
// module chunks = 21